import React from 'react';
import PropTypes from 'prop-types';


import FormSelect from '../../../global/Form/FormElement/FormSelect';
import LanguageSelectForm from '../LanguageSelectForm';
import usePlatformLanguages from '../hooks/usePlatformLanguages';


function PlatformLanguageSelectForm(props) {

    const platformLanguages = usePlatformLanguages();

    return (
        <LanguageSelectForm
            languages={platformLanguages}
            {...props}
        />
    );
}


PlatformLanguageSelectForm.propTypes = {
    ...FormSelect.propTypes,
    value: PropTypes.string
};


PlatformLanguageSelectForm.defaultProps = {
    ...LanguageSelectForm.defaultProps
};


export default PlatformLanguageSelectForm;
